export default __webpack_public_path__ + "static/media/question.70b4b477.svg";